import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouteIdentifier, RouteParams } from 'types/routing';
import { QueryParams } from 'types/transport';
import { useLocationDescriptor } from './useLocationDescriptor';

export const useRedirector = <
  TParams extends RouteParams = RouteParams,
  TQuery extends QueryParams = QueryParams,
>(
  routeId: RouteIdentifier,
) => {
  // Retrieve browser history manager
  const navigate = useNavigate();

  // Instantiate location descriptor creator
  const createLocationDescriptor = useLocationDescriptor(routeId);

  return useCallback(
    (params?: TParams, query?: Partial<TQuery>, replace = false) => {
      // Create location descriptor object
      const location = createLocationDescriptor(params, query);

      // Redirect to the generated location
      navigate(location, { replace });
    },
    [createLocationDescriptor, navigate],
  );
};
